import PropTypes from 'prop-types';
import React from 'react';
import Ad from '../common/ad';
import { SEE_ALL_SLIDES_AD_SIZES } from '../../utils/ads/sizes';

const SeeAllSlidesAd = ({ adsState, adPosition }) => (
  <div className="thumbnail-row-ad">
    <Ad adsState={adsState}
      sizes={SEE_ALL_SLIDES_AD_SIZES}
      position={adPosition}
      uniqueId={`see-all-slides-${adPosition}`}
    />
  </div>
);

SeeAllSlidesAd.propTypes = {
  adsState: PropTypes.object.isRequired,
  adPosition: PropTypes.string.isRequired
};

export default SeeAllSlidesAd;
